import React, { Component } from 'react'
// import Detect from 'three/examples/js/Detector'
import BrowserApp from '../containers/BrowserApp'
import MobileApp from '../containers/MobileApp'

import Superface from '../Superface'

// const WEBGL_CAPABLE = Detect.webgl

export default class App extends Component {

	componentDidMount(){
		window.addEventListener('resize', () => {
			this.setState({})
		})
	}

	renderApp(){
		
		if( Superface.IS_MOBILE_OR_TABLET ){
			return <MobileApp />
		}else{
			return <BrowserApp />
		}

	}

	render() {
		return(
			<div style={{width:'100%', height:'100%'}}>
				{this.renderApp()}
			</div>
		)
	}

	
}







// WEBPACK FOOTER //
// ./src/components/App.js